"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloudMetadata = void 0;
/**
 * coordinates based on
 * https://docs.google.com/spreadsheets/d/1cRMVRVG_-W2VVcnv7yURpdsCpg-16OQGOZwY2__u2CU/edit#gid=0
 */
const cloudMetadata = exports.cloudMetadata = {
  aws: {
    name: 'Amazon Web Services',
    regions: {
      'us-east-1': {
        name: 'US East (N. Virginia)',
        coordinates: {
          lat: 39.0299591,
          lon: -77.4946755
        }
      },
      'us-east-1-wl1-atl-wlz-1': {
        name: 'US East (Atlanta)',
        coordinates: {
          lat: 33.753746,
          lon: -84.38633
        }
      },
      'us-east-1-wl1-iah-wlz-1': {
        name: 'US East (Houston)',
        coordinates: {
          lat: 29.749907,
          lon: -95.358421
        }
      },
      'us-east-2': {
        name: 'US East (Ohio)',
        coordinates: {
          lat: 39.9829303,
          lon: -83.0610394
        }
      },
      'us-west-1': {
        name: 'US West (N. California)',
        coordinates: {
          lat: 37.296841,
          lon: -121.8876234
        }
      },
      'us-west-2': {
        name: 'US West (Oregon)',
        coordinates: {
          lat: 45.6094796,
          lon: -121.1914129
        }
      },
      'us-west-2-wl1-den-wlz-1': {
        name: 'US West (Denver)',
        coordinates: {
          lat: 39.73915,
          lon: -104.9847
        }
      },
      'af-south-1': {
        name: 'Africa (Cape Town)',
        coordinates: {
          lat: -33.9154584,
          lon: 18.5156366
        }
      },
      'ap-east-1': {
        name: 'Asia Pacific (Hong Kong)',
        coordinates: {
          lat: 22.396427,
          lon: 114.109497
        }
      },
      'ap-east-2': {
        name: 'Asia Pacific (Taipei)',
        coordinates: {
          lat: 25.105497,
          lon: 121.597366
        }
      },
      'ap-south-1': {
        name: 'Asia Pacific (Mumbai)',
        coordinates: {
          lat: 19.0822375,
          lon: 72.8109756
        }
      },
      'ap-south-2': {
        name: 'Asia Pacific (Hyderabad)',
        coordinates: {
          lat: 17.366,
          lon: 78.476
        }
      },
      'ap-northeast-1': {
        name: 'Asia Pacific (Tokyo)',
        coordinates: {
          lat: 35.689487,
          lon: 139.691711
        }
      },
      'ap-northeast-1-wl1-nrt-wlz-1': {
        name: 'Asia Pacific (Tokyo)',
        coordinates: {
          lat: 35.689487,
          lon: 139.691711
        }
      },
      'ap-northeast-2': {
        name: 'Asia Pacific (Seoul)',
        coordinates: {
          lat: 37.5650792,
          lon: 126.9193396
        }
      },
      'ap-northeast-2-wl1-cjj-wlz-1': {
        name: 'Asia Pacific (Daejeon)',
        coordinates: {
          lat: 36.34639,
          lon: 127.415955
        }
      },
      'ap-northeast-3': {
        name: 'Asia Pacific (Osaka-Local)',
        coordinates: {
          lat: 34.6776384,
          lon: 135.4509596
        }
      },
      'ap-southeast-1': {
        name: 'Asia Pacific (Singapore)',
        coordinates: {
          lat: 1.3139991,
          lon: 103.7740394
        }
      },
      'ap-southeast-2': {
        name: 'Asia Pacific (Sydney)',
        coordinates: {
          lat: -33.8481643,
          lon: 150.791552
        }
      },
      'ap-southeast-3': {
        name: 'Asia Pacific (Jakarta)',
        coordinates: {
          lat: -6.2297453,
          lon: 106.794413
        }
      },
      'ap-southeast-4': {
        name: 'Asia Pacific (Melbourne)',
        coordinates: {
          lat: -37.840935,
          lon: 144.946457
        }
      },
      'ap-southeast-5': {
        name: 'Asia Pacific (Malaysia)',
        coordinates: {
          lat: 3.139,
          lon: 101.6869
        }
      },
      'ap-southeast-6': {
        name: 'Asia Pacific (New Zealand)',
        coordinates: {
          lat: -36.84599227,
          lon: 174.782331
        }
      },
      'ap-southeast-7': {
        name: 'Asia Pacific (Thailand)',
        coordinates: {
          lat: 13.736717,
          lon: 100.523186
        }
      },
      'ca-central-1': {
        name: 'Canada (Central)',
        coordinates: {
          lat: 45.5580205,
          lon: -73.8005128
        }
      },
      'ca-west-1': {
        name: 'Canada (West)',
        coordinates: {
          lat: 51.05,
          lon: 114.07
        }
      },
      'cn-north-1': {
        name: 'China (Beijing)',
        coordinates: {
          lat: 39.9387991,
          lon: 116.2570364
        }
      },
      'cn-northwest-1': {
        name: 'China (Ningxia)',
        coordinates: {
          lat: 37.3046246,
          lon: 104.8495804
        }
      },
      'eu-central-1': {
        name: 'Europe (Frankfurt)',
        coordinates: {
          lat: 50.1211908,
          lon: 8.5663536
        }
      },
      'eu-central-2': {
        name: 'Europe (Zurich)',
        coordinates: {
          lat: 47.3769,
          lon: 8.5417
        }
      },
      'eu-west-1': {
        name: 'Europe (Ireland)',
        coordinates: {
          lat: 53.3242995,
          lon: -6.3159143
        }
      },
      'eu-west-2': {
        name: 'Europe (London)',
        coordinates: {
          lat: 51.5286207,
          lon: -0.1718088
        }
      },
      'eu-west-2-wl1-lon-wlz-1': {
        name: 'Europe (London)',
        coordinates: {
          lat: 51.5286207,
          lon: -0.1718088
        }
      },
      'eu-west-3': {
        name: 'Europe (Paris)',
        coordinates: {
          lat: 48.8588536,
          lon: 2.311955
        }
      },
      'eu-north-1': {
        name: 'Europe (Stockholm)',
        coordinates: {
          lat: 59.3261231,
          lon: 17.9118424
        }
      },
      'eu-south-1': {
        name: 'Europe (Milan)',
        coordinates: {
          lat: 45.4627285,
          lon: 9.1426273
        }
      },
      'eu-south-2': {
        name: 'Europe (Spain)',
        coordinates: {
          lat: 40.4168,
          lon: -3.7038
        }
      },
      'il-central-1': {
        name: 'Israel (Tel Aviv)',
        coordinates: {
          lat: 32.0853,
          lon: 34.7818
        }
      },
      'me-central-1': {
        name: 'Middle East (UAE)',
        coordinates: {
          lat: 25.2048,
          lon: 55.2708
        }
      },
      // 'me-south-1': {
      //   name: 'Middle East (Bahrain)',
      //   coordinates: { lat: 26.2266156, lon: 50.5714394 }
      // },
      'mx-central-1': {
        name: 'Mexico (Central)',
        coordinates: {
          lat: 19.4326,
          lon: -99.1332
        }
      },
      'sa-east-1': {
        name: 'South America (Sao Paulo)',
        coordinates: {
          lat: -23.6823491,
          lon: -46.7357224
        }
      },
      'us-gov-east-1': {
        name: 'AWS GovCloud (US-East)',
        coordinates: null
      },
      'us-gov-west-1': {
        name: 'AWS GovCloud (US)',
        coordinates: null
      }
    }
  },
  gcp: {
    name: 'Google Cloud Platform',
    regions: {
      'africa-south1': {
        name: 'Johannesburg',
        coordinates: {
          lat: -26.195246,
          lon: 28.034088
        }
      },
      'asia-east1': {
        name: 'Taiwan',
        coordinates: {
          lat: 24.078176,
          lon: 120.545807
        }
      },
      'asia-east2': {
        name: 'Hong Kong',
        coordinates: {
          lat: 22.396427,
          lon: 114.109497
        }
      },
      'asia-northeast1': {
        name: 'Tokyo',
        coordinates: {
          lat: 35.689487,
          lon: 139.691711
        }
      },
      'asia-northeast2': {
        name: 'Osaka',
        coordinates: {
          lat: 34.693737,
          lon: 135.502167
        }
      },
      'asia-northeast3': {
        name: 'Seoul',
        coordinates: {
          lat: 37.566536,
          lon: 126.977966
        }
      },
      'asia-south1': {
        name: 'Mumbai',
        coordinates: {
          lat: 19.075983,
          lon: 72.877655
        }
      },
      'asia-south2': {
        name: 'Delhi',
        coordinates: {
          lat: 28.5562,
          lon: 77.1
        }
      },
      'asia-southeast1': {
        name: 'Singapore',
        coordinates: {
          lat: 1.3139991,
          lon: 103.7740394
        }
      },
      'asia-southeast2': {
        name: 'Jakarta',
        coordinates: {
          lat: -6.2297453,
          lon: 106.794413
        }
      },
      'australia-southeast1': {
        name: 'Sydney',
        coordinates: {
          lat: -33.8481643,
          lon: 150.791552
        }
      },
      'australia-southeast2': {
        name: 'Melbourne',
        coordinates: {
          lat: -37.840935,
          lon: 144.946457
        }
      },
      'europe-central2': {
        name: 'Warsaw',
        coordinates: {
          lat: 52.22977,
          lon: 21.01178
        }
      },
      'europe-north1': {
        name: 'Finland',
        coordinates: {
          lat: 60.5695909,
          lon: 27.2009669
        }
      },
      'europe-west1': {
        name: 'Belgium',
        coordinates: {
          lat: 50.4898397,
          lon: 3.772815
        }
      },
      'europe-north2': {
        name: 'Stockholm',
        coordinates: {
          lat: 59.3251172,
          lon: 18.0710935
        }
      },
      'europe-west2': {
        name: 'London',
        coordinates: {
          lat: 51.5286207,
          lon: -0.1718088
        }
      },
      'europe-west3': {
        name: 'Frankfurt',
        coordinates: {
          lat: 50.1211908,
          lon: 8.5663536
        }
      },
      'europe-west4': {
        name: 'Netherlands',
        coordinates: {
          lat: 53.4585885,
          lon: 6.8288005
        }
      },
      'europe-west6': {
        name: 'Zurich',
        coordinates: {
          lat: 47.3774496,
          lon: 8.5016101
        }
      },
      'europe-west8': {
        name: 'Milan',
        coordinates: {
          lat: 45.4642,
          lon: 9.19
        }
      },
      'europe-west9': {
        name: 'Paris',
        coordinates: {
          lat: 48.8566,
          lon: 2.3522
        }
      },
      'europe-west10': {
        name: 'Berlin',
        coordinates: {
          lat: 52.52,
          lon: 13.405
        }
      },
      'europe-west12': {
        name: 'Turin',
        coordinates: {
          lat: 45.0703,
          lon: 7.6869
        }
      },
      'europe-southwest1': {
        name: 'Madrid',
        coordinates: {
          lat: 40.4168,
          lon: -3.7038
        }
      },
      'northamerica-northeast1': {
        name: 'Montreal',
        coordinates: {
          lat: 45.5580205,
          lon: -73.8005128
        }
      },
      'northamerica-northeast2': {
        name: 'Toronto',
        coordinates: {
          lat: 43.70011,
          lon: -79.4163
        }
      },
      'northamerica-south1': {
        name: 'Queretaro',
        coordinates: {
          lat: 20.5881,
          lon: -100.3881
        }
      },
      'southamerica-east1': {
        name: 'Osasco',
        coordinates: {
          lat: -23.6823491,
          lon: -46.7357224
        }
      },
      'southamerica-west1': {
        name: 'Santiago',
        coordinates: {
          lat: -33.42628,
          lon: -70.56656
        }
      },
      'us-central1': {
        name: 'Iowa',
        coordinates: {
          lat: 41.2327116,
          lon: -95.8817859
        }
      },
      'us-east1': {
        name: 'South Carolina',
        coordinates: {
          lat: 33.1974307,
          lon: -80.0100507
        }
      },
      'us-east4': {
        name: 'Northern Virginia',
        coordinates: {
          lat: 39.0299591,
          lon: -77.4946755
        }
      },
      'us-west1': {
        name: 'Oregon',
        coordinates: {
          lat: 45.6094796,
          lon: -121.1914129
        }
      },
      'us-west2': {
        name: 'Los Angeles',
        coordinates: {
          lat: 34.0203992,
          lon: -118.5521553
        }
      },
      'us-west3': {
        name: 'Salt Lake City',
        coordinates: {
          lat: 40.7766026,
          lon: -111.95559
        }
      },
      'us-west4': {
        name: 'Las Vegas',
        coordinates: {
          lat: 36.1249795,
          lon: -115.2452104
        }
      },
      'us-east5': {
        name: 'Columbus',
        coordinates: {
          lat: 39.9612,
          lon: -82.9988
        }
      },
      'us-south1': {
        name: 'Dallas',
        coordinates: {
          lat: 32.7767,
          lon: -96.797
        }
      },
      'me-central1': {
        name: 'Doha',
        coordinates: {
          lat: 25.2769,
          lon: 51.5201
        }
      },
      'me-central2': {
        name: 'Dammam',
        coordinates: {
          lat: 26.4257,
          lon: 50.0552
        }
      },
      'me-west1': {
        name: 'Tel Aviv',
        coordinates: {
          lat: 32.0853,
          lon: 34.7818
        }
      },
      'asia-southeast3': {
        name: 'Bangkok',
        coordinates: {
          lat: 13.754,
          lon: 100.5014
        }
      }
    }
  },
  azure: {
    name: 'Microsoft Azure',
    regions: {
      asia: {
        name: 'Asia',
        coordinates: {
          lat: 35.6762,
          lon: 139.6503
        }
      },
      asiapacific: {
        name: 'Asia Pacific',
        coordinates: {
          lat: 1.3521,
          lon: 103.8198
        }
      },
      australia: {
        name: 'Australia',
        coordinates: {
          lat: -25.2744,
          lon: 133.7751
        }
      },
      australiacentral: {
        name: 'Australia Central',
        coordinates: {
          lat: -35.3139595,
          lon: 149.0595721
        }
      },
      australiacentral2: {
        name: 'Australia Central 2',
        coordinates: {
          lat: -35.3139595,
          lon: 149.0595721
        }
      },
      australiaeast: {
        name: 'Australia East',
        coordinates: {
          lat: -33.8481643,
          lon: 150.791552
        }
      },
      australiasoutheast: {
        name: 'Australia Southeast',
        coordinates: {
          lat: -37.972483,
          lon: 144.9127127
        }
      },
      brazil: {
        name: 'Brazil',
        coordinates: {
          lat: -22.9141153,
          lon: -43.5161926
        }
      },
      brazilsouth: {
        name: 'Brazil South',
        coordinates: {
          lat: -23.6823491,
          lon: -46.7357224
        }
      },
      brazilsoutheast: {
        name: 'Brazil Southeast',
        coordinates: {
          lat: -22.9068467,
          lon: -43.1728965
        }
      },
      canada: {
        name: 'Canada',
        coordinates: {
          lat: 56.1304,
          lon: -106.3468
        }
      },
      canadacentral: {
        name: 'Canada Central',
        coordinates: {
          lat: 43.7182197,
          lon: -79.4482684
        }
      },
      canadaeast: {
        name: 'Canada East',
        coordinates: {
          lat: 46.8563469,
          lon: -71.4119028
        }
      },
      centralindia: {
        name: 'Central India',
        coordinates: {
          lat: 18.5246132,
          lon: 73.8278624
        }
      },
      centralus: {
        name: 'Central US',
        coordinates: {
          lat: 41.5666646,
          lon: -93.641621
        }
      },
      centraluseuap: {
        name: 'Central US EUAP',
        coordinates: {
          lat: 41.5666646,
          lon: -93.641621
        }
      },
      centralusstage: {
        name: 'Central US (Stage)',
        coordinates: {
          lat: 41.5666646,
          lon: -93.641621
        }
      },
      chilecentral: {
        name: 'Chile Central',
        coordinates: {
          lat: -33.4475,
          lon: -70.6737
        }
      },
      eastasia: {
        name: 'East Asia',
        coordinates: {
          lat: 22.396427,
          lon: 114.109497
        }
      },
      eastasiastage: {
        name: 'East Asia (Stage)',
        coordinates: {
          lat: 22.396427,
          lon: 114.109497
        }
      },
      eastus: {
        name: 'East US',
        coordinates: {
          lat: 39.0299591,
          lon: -77.4946755
        }
      },
      eastus2: {
        name: 'East US 2',
        coordinates: {
          lat: 36.665756,
          lon: -78.3927041
        }
      },
      eastus2euap: {
        name: 'East US 2 EUAP',
        coordinates: {
          lat: 36.665756,
          lon: -78.3927041
        }
      },
      eastus2stage: {
        name: 'East US 2 (Stage)',
        coordinates: {
          lat: 36.665756,
          lon: -78.3927041
        }
      },
      eastusstage: {
        name: 'East US (Stage)',
        coordinates: {
          lat: 39.0299591,
          lon: -77.4946755
        }
      },
      europe: {
        name: 'Europe',
        coordinates: {
          lat: 54.526,
          lon: 15.2551
        }
      },
      francecentral: {
        name: 'France Central',
        coordinates: {
          lat: 48.8588536,
          lon: 2.311955
        }
      },
      francesouth: {
        name: 'France South',
        coordinates: {
          lat: 43.2803852,
          lon: 5.3453915
        }
      },
      germanynorth: {
        name: 'Germany North',
        coordinates: {
          lat: 52.5068233,
          lon: 13.3545216
        }
      },
      germanywestcentral: {
        name: 'Germany West Central',
        coordinates: {
          lat: 50.1211908,
          lon: 8.5663536
        }
      },
      global: {
        name: 'Global',
        coordinates: {
          lat: 0,
          lon: 0
        }
      },
      india: {
        name: 'India',
        coordinates: {
          lat: 18.5246132,
          lon: 73.8278624
        }
      },
      japan: {
        name: 'Japan',
        coordinates: {
          lat: 36.2048,
          lon: 138.2529
        }
      },
      japaneast: {
        name: 'Japan East',
        coordinates: {
          lat: 35.689487,
          lon: 139.691711
        }
      },
      japanwest: {
        name: 'Japan West',
        coordinates: {
          lat: 34.6776384,
          lon: 135.4509596
        }
      },
      jioindiacentral: {
        name: 'Jio India Central',
        coordinates: {
          lat: 21.146633,
          lon: 79.08886
        }
      },
      jioindiawest: {
        name: 'Jio India West',
        coordinates: {
          lat: 22.470701,
          lon: 70.05773
        }
      },
      koreacentral: {
        name: 'Korea Central',
        coordinates: {
          lat: 37.5650792,
          lon: 126.9193396
        }
      },
      koreasouth: {
        name: 'Korea South',
        coordinates: {
          lat: 35.1644449,
          lon: 129.036695
        }
      },
      mexicocentral: {
        name: 'Mexico Central',
        coordinates: {
          lat: 20.588818,
          lon: -100.389888
        }
      },
      northcentralus: {
        name: 'North Central US',
        coordinates: {
          lat: 41.8337116,
          lon: -87.8021743
        }
      },
      northcentralusstage: {
        name: 'North Central US (Stage)',
        coordinates: {
          lat: 41.8337116,
          lon: -87.8021743
        }
      },
      northeurope: {
        name: 'North Europe',
        coordinates: {
          lat: 53.3242995,
          lon: -6.3159143
        }
      },
      norwayeast: {
        name: 'Norway East',
        coordinates: {
          lat: 59.8938363,
          lon: 10.7149064
        }
      },
      norwaywest: {
        name: 'Norway West',
        coordinates: {
          lat: 58.9486486,
          lon: 5.6452319
        }
      },
      qatarcentral: {
        name: 'Qatar Central',
        coordinates: {
          lat: 25.2769,
          lon: 51.5201
        }
      },
      southafricanorth: {
        name: 'South Africa North',
        coordinates: {
          lat: -26.1715172,
          lon: 28.0049195
        }
      },
      southafricawest: {
        name: 'South Africa West',
        coordinates: {
          lat: -33.9154584,
          lon: 18.5156366
        }
      },
      southcentralus: {
        name: 'South Central US',
        coordinates: {
          lat: 29.4814121,
          lon: -98.5846149
        }
      },
      southcentralusstage: {
        name: 'South Central US (Stage)',
        coordinates: {
          lat: 29.4814121,
          lon: -98.5846149
        }
      },
      southeastasia: {
        name: 'Southeast Asia',
        coordinates: {
          lat: 1.3139991,
          lon: 103.7740394
        }
      },
      southeastasiastage: {
        name: 'Southeast Asia (Stage)',
        coordinates: {
          lat: 1.3139991,
          lon: 103.7740394
        }
      },
      southindia: {
        name: 'South India',
        coordinates: {
          lat: 13.047516,
          lon: 80.1388011
        }
      },
      swedencentral: {
        name: 'Sweden Central',
        coordinates: {
          lat: 60.6749,
          lon: 17.1413
        }
      },
      swedensouth: {
        name: 'Sweden South',
        coordinates: {
          lat: 55.6058,
          lon: 13.0007
        }
      },
      switzerlandnorth: {
        name: 'Switzerland North',
        coordinates: {
          lat: 47.3774496,
          lon: 8.5016101
        }
      },
      switzerlandwest: {
        name: 'Switzerland West',
        coordinates: {
          lat: 46.2050282,
          lon: 6.1265361
        }
      },
      uaecentral: {
        name: 'UAE Central',
        coordinates: {
          lat: 24.3868144,
          lon: 54.4884099
        }
      },
      uaenorth: {
        name: 'UAE North',
        coordinates: {
          lat: 25.0752822,
          lon: 55.0873236
        }
      },
      uk: {
        name: 'United Kingdom',
        coordinates: {
          lat: 55.3781,
          lon: -3.436
        }
      },
      uksouth: {
        name: 'UK South',
        coordinates: {
          lat: 51.5286207,
          lon: -0.1718088
        }
      },
      ukwest: {
        name: 'UK West',
        coordinates: {
          lat: 51.5022355,
          lon: -3.2401549
        }
      },
      unitedstates: {
        name: 'United States',
        coordinates: {
          lat: 37.0902,
          lon: -95.7129
        }
      },
      westcentralus: {
        name: 'West Central US',
        coordinates: {
          lat: 41.1475272,
          lon: -104.8025095
        }
      },
      westeurope: {
        name: 'West Europe',
        coordinates: {
          lat: 52.3546604,
          lon: 4.8688555
        }
      },
      westindia: {
        name: 'West India',
        coordinates: {
          lat: 19.0822375,
          lon: 72.8109756
        }
      },
      westus: {
        name: 'West US',
        coordinates: {
          lat: 37.3708892,
          lon: -121.985105
        }
      },
      westus2: {
        name: 'West US 2',
        coordinates: {
          lat: 47.2273466,
          lon: -119.8625497
        }
      },
      westus2stage: {
        name: 'West US 2 (Stage)',
        coordinates: {
          lat: 47.2273466,
          lon: -119.8625497
        }
      },
      westus3: {
        name: 'West US 3',
        coordinates: {
          lat: 33.4484,
          lon: -112.074
        }
      },
      westusstage: {
        name: 'West US (Stage)',
        coordinates: {
          lat: 37.3708892,
          lon: -121.985105
        }
      },
      // china
      chinaeast: {
        name: 'China East (Shanghai)',
        coordinates: {
          lat: 31.3209,
          lon: 121.5891
        }
      },
      chinaeast2: {
        name: 'China East 2 (Shanghai)',
        coordinates: {
          lat: 31.3209,
          lon: 121.5891
        }
      },
      chinanorth: {
        name: 'China North (Beijing)',
        coordinates: {
          lat: 39.9788,
          lon: 116.4959
        }
      },
      chinanorth2: {
        name: 'China North 2 (Beijing)',
        coordinates: {
          lat: 39.9788,
          lon: 116.4959
        }
      },
      chinanorth3: {
        name: 'China North 3 (Zhangjiakou)',
        coordinates: {
          lat: 40.7675,
          lon: 114.8863
        }
      },
      // New regions added in 2023-2025
      israelcentral: {
        name: 'Israel Central',
        coordinates: {
          lat: 31.78,
          lon: 35.22
        }
      },
      italynorth: {
        name: 'Italy North',
        coordinates: {
          lat: 45.4642,
          lon: 9.19
        }
      },
      polandcentral: {
        name: 'Poland Central',
        coordinates: {
          lat: 52.2297,
          lon: 21.0122
        }
      },
      spaincentral: {
        name: 'Spain Central',
        coordinates: {
          lat: 40.4168,
          lon: -3.7038
        }
      },
      austriaeast: {
        name: 'Austria East',
        coordinates: {
          lat: 48.2082,
          lon: 16.3738
        }
      },
      belgiumcentral: {
        name: 'Belgium Central',
        coordinates: {
          lat: 50.8503,
          lon: 4.3517
        }
      },
      denmarkeast: {
        name: 'Denmark East',
        coordinates: {
          lat: 55.6761,
          lon: 12.5683
        }
      },
      finlandcentral: {
        name: 'Finland Central',
        coordinates: {
          lat: 60.1699,
          lon: 24.9384
        }
      },
      greececentral: {
        name: 'Greece Central',
        coordinates: {
          lat: 37.9755,
          lon: 23.7348
        }
      },
      indonesiacentral: {
        name: 'Indonesia Central',
        coordinates: {
          lat: -6.2088,
          lon: 106.8456
        }
      },
      malaysiawest: {
        name: 'Malaysia West',
        coordinates: {
          lat: 3.139,
          lon: 101.6869
        }
      },
      newzealandnorth: {
        name: 'New Zealand North',
        coordinates: {
          lat: -36.8485,
          lon: 174.7633
        }
      },
      taiwannorth: {
        name: 'Taiwan North',
        coordinates: {
          lat: 25.033,
          lon: 121.5654
        }
      }
    }
  },
  alibaba: {
    name: 'Alibaba Cloud',
    regions: {
      'cn-qingdao': {
        name: 'China (Qingdao)',
        coordinates: null
      },
      'cn-beijing': {
        name: 'China (Beijing)',
        coordinates: null
      },
      'cn-zhangjiakou': {
        name: 'China (Zhangjiakou)',
        coordinates: null
      },
      'cn-guangzhou': {
        name: 'China (Guangzhou)',
        coordinates: null
      },
      'cn-huhehaote': {
        name: 'China (Hohhot)',
        coordinates: null
      },
      'cn-wulanchabu': {
        name: 'China (Ulanqab)',
        coordinates: null
      },
      'cn-hangzhou': {
        name: 'China (Hangzhou)',
        coordinates: null
      },
      'cn-shanghai': {
        name: 'China (Shanghai)',
        coordinates: null
      },
      'cn-shenzhen': {
        name: 'China (Shenzhen)',
        coordinates: null
      },
      'cn-heyuan': {
        name: 'China (Heyuan)',
        coordinates: null
      },
      'cn-chengdu': {
        name: 'China (Chengdu)',
        coordinates: null
      },
      'cn-hongkong': {
        name: 'China (Hong Kong)',
        coordinates: null
      },
      'ap-southeast-1': {
        name: 'Singapore',
        coordinates: null
      },
      'ap-southeast-2': {
        name: 'Australia (Sydney)',
        coordinates: null
      },
      'ap-southeast-3': {
        name: 'Malaysia (Kuala Lumpur)',
        coordinates: null
      },
      'ap-southeast-5': {
        name: 'Indonesia (Jakarta)',
        coordinates: null
      },
      'ap-southeast-6': {
        name: 'Phillippines (Manila)',
        coordinates: null
      },
      'ap-south-1': {
        name: 'India (Mumbai)',
        coordinates: null
      },
      'ap-northeast-1': {
        name: 'Japan (Tokyo)',
        coordinates: null
      },
      'us-west-1': {
        name: 'US (Silicon Valley)',
        coordinates: null
      },
      'us-east-1': {
        name: 'US (Virginia)',
        coordinates: null
      },
      'eu-central-1': {
        name: 'Germany (Frankfurt)',
        coordinates: null
      },
      'eu-west-1': {
        name: 'UK (London)',
        coordinates: null
      },
      'me-east-1': {
        name: 'UAE (Dubai)',
        coordinates: null
      }
    }
  },
  ibm: {
    name: 'IBM Cloud',
    regions: {
      'eu-de': {
        name: 'Frankfurt',
        coordinates: null
      },
      'eu-gb': {
        name: 'London',
        coordinates: null
      },
      'us-south': {
        name: 'Dallas',
        coordinates: null
      },
      'us-east': {
        name: 'Washington, D.C.',
        coordinates: null
      },
      'au-syd': {
        name: 'Sydney',
        coordinates: null
      },
      'jp-tok': {
        name: 'Tokyo',
        coordinates: null
      },
      ams03: {
        name: 'Amsterdam',
        coordinates: null
      },
      che01: {
        name: 'Chennai',
        coordinates: null
      },
      dal10: {
        name: 'Dallas',
        coordinates: null
      },
      fra05: {
        name: 'Frankfurt',
        coordinates: null
      },
      lon05: {
        name: 'London',
        coordinates: null
      },
      mil01: {
        name: 'Milan',
        coordinates: null
      },
      par01: {
        name: 'Paris',
        coordinates: null
      },
      sao01: {
        name: 'Sao Paulo',
        coordinates: null
      },
      sjc03: {
        name: 'San Jose',
        coordinates: null
      },
      sng01: {
        name: 'Singapore',
        coordinates: null
      },
      syd05: {
        name: 'Sydney',
        coordinates: null
      },
      tor01: {
        name: 'Toronto',
        coordinates: null
      },
      tok05: {
        name: 'Tokyo',
        coordinates: null
      },
      wdc04: {
        name: 'Washington, D.C.',
        coordinates: null
      }
    }
  },
  oci: {
    name: 'OCI Cloud',
    regions: {
      'ap-sydney-1': {
        name: 'Sydney',
        coordinates: {
          lat: -33.87,
          lon: 151.21
        }
      },
      'ap-melbourne-1': {
        name: 'Melbourne',
        coordinates: {
          lat: -37.81,
          lon: 144.96
        }
      },
      'sa-saopaulo-1': {
        name: 'Sao Paulo',
        coordinates: {
          lat: -23.55,
          lon: -46.63
        }
      },
      'sa-vinhedo-1': {
        name: 'Vinhedo',
        coordinates: {
          lat: -23.02,
          lon: -46.99
        }
      },
      'ca-montreal-1': {
        name: 'Montreal',
        coordinates: {
          lat: 45.5,
          lon: -73.57
        }
      },
      'ca-toronto-1': {
        name: 'Toronto',
        coordinates: {
          lat: 43.65,
          lon: -79.38
        }
      },
      'sa-santiago-1': {
        name: 'Santiago',
        coordinates: {
          lat: -33.45,
          lon: -70.66
        }
      },
      'sa-bogota-1': {
        name: 'Bogota',
        coordinates: {
          lat: 4.60971,
          lon: -74.08175
        }
      },
      'sa-valparaiso-1': {
        name: 'Valparaiso',
        coordinates: {
          lat: -33.036,
          lon: -71.62963
        }
      },
      'eu-paris-1': {
        name: 'Paris',
        coordinates: {
          lat: 48.86,
          lon: 2.35
        }
      },
      'eu-marseille-1': {
        name: 'Marseille',
        coordinates: {
          lat: 43.3,
          lon: 5.38
        }
      },
      'eu-frankfurt-1': {
        name: 'Frankfurt',
        coordinates: {
          lat: 50.11,
          lon: 8.68
        }
      },
      'ap-hyderabad-1': {
        name: 'Hyderabad',
        coordinates: {
          lat: 17.38,
          lon: 78.48
        }
      },
      'ap-mumbai-1': {
        name: 'Mumbai',
        coordinates: {
          lat: 19.08,
          lon: 72.88
        }
      },
      'il-jerusalem-1': {
        name: 'Jerusalem',
        coordinates: {
          lat: 31.78,
          lon: 35.22
        }
      },
      'eu-milan-1': {
        name: 'Milan',
        coordinates: {
          lat: 45.46,
          lon: 9.19
        }
      },
      'ap-osaka-1': {
        name: 'Osaka',
        coordinates: {
          lat: 34.7,
          lon: 135.5
        }
      },
      'ap-tokyo-1': {
        name: 'Tokyo',
        coordinates: {
          lat: 35.69,
          lon: 139.69
        }
      },
      'mx-queretaro-1': {
        name: 'Queretaro',
        coordinates: {
          lat: 20.59,
          lon: -100.39
        }
      },
      'eu-amsterdam-1': {
        name: 'Amsterdam',
        coordinates: {
          lat: 52.37,
          lon: 4.9
        }
      },
      'me-jeddah-1': {
        name: 'Jeddah',
        coordinates: {
          lat: 21.54,
          lon: 39.17
        }
      },
      'eu-jovanovac-1': {
        name: 'Jovanovac',
        coordinates: {
          lat: 45.07,
          lon: 18.69
        }
      },
      'ap-singapore-1': {
        name: 'Singapore',
        coordinates: {
          lat: 1.29,
          lon: 103.85
        }
      },
      'ap-singapore-2': {
        name: 'Singapore West',
        coordinates: {
          lat: 1.29027,
          lon: 103.851959
        }
      },
      'af-johannesburg-1': {
        name: 'Johannesburg',
        coordinates: {
          lat: -26.2,
          lon: 28.04
        }
      },
      'ap-batam-1': {
        name: 'Batam',
        coordinates: {
          lat: 1.1494,
          lon: 104.0249
        }
      },
      'ap-seoul-1': {
        name: 'Seoul',
        coordinates: {
          lat: 37.57,
          lon: 126.98
        }
      },
      'ap-chuncheon-1': {
        name: 'Chuncheon',
        coordinates: {
          lat: 37.88,
          lon: 127.73
        }
      },
      'eu-madrid-1': {
        name: 'Madrid',
        coordinates: {
          lat: 40.42,
          lon: -3.7
        }
      },
      'eu-madrid-3': {
        name: 'Madrid',
        coordinates: {
          lat: 40.4165,
          lon: -3.70256
        }
      },
      'eu-stockholm-1': {
        name: 'Stockholm',
        coordinates: {
          lat: 59.33,
          lon: 18.07
        }
      },
      'eu-turin-1': {
        name: 'Turin',
        coordinates: null
      },
      'eu-zurich-1': {
        name: 'Zurich',
        coordinates: {
          lat: 47.37,
          lon: 8.54
        }
      },
      'me-abudhabi-1': {
        name: 'Abu Dhabi',
        coordinates: {
          lat: 24.46,
          lon: 54.37
        }
      },
      'me-dubai-1': {
        name: 'Dubai',
        coordinates: {
          lat: 25.2,
          lon: 55.27
        }
      },
      'uk-london-1': {
        name: 'London',
        coordinates: {
          lat: 51.51,
          lon: -0.13
        }
      },
      'uk-cardiff-1': {
        name: 'Cardiff',
        coordinates: {
          lat: 51.48,
          lon: -3.18
        }
      },
      'us-ashburn-1': {
        name: 'Ashburn',
        coordinates: {
          lat: 39.04,
          lon: -77.48
        }
      },
      'us-chicago-1': {
        name: 'Chicago',
        coordinates: {
          lat: 41.88,
          lon: -87.63
        }
      },
      'us-shawnee-1': {
        name: 'US Midwest (Shawnee)',
        regionCode: 'drz',
        realm: {
          id: 'oc1',
          secondLevelDomain: 'oraclecloud.com'
        },
        coordinates: {
          lat: 39.0317,
          lon: -94.7202
        }
      },
      'us-lenexa-1': {
        name: 'US Midwest (Lenexa)',
        regionCode: 'drz',
        realm: {
          id: 'oc1',
          secondLevelDomain: 'oraclecloud.com'
        },
        coordinates: {
          lat: 38.9647,
          lon: -94.7556
        }
      },
      'us-phoenix-1': {
        name: 'Phoenix',
        coordinates: {
          lat: 33.43,
          lon: -112.02
        }
      },
      'us-sanjose-1': {
        name: 'San Jose',
        coordinates: {
          lat: 37.33,
          lon: -121.89
        }
      },
      'mx-monterrey-1': {
        name: 'Monterrey',
        coordinates: {
          lat: 25.68,
          lon: -100.31
        }
      },
      'me-riyadh-1': {
        name: 'Riyadh',
        coordinates: {
          lat: 24.77,
          lon: 46.74
        }
      },
      'af-casablanca-1': {
        name: 'Casablanca',
        coordinates: {
          lat: 33.59,
          lon: -7.61
        }
      },
      'ap-kulai-2': {
        name: 'Kulai',
        coordinates: {
          lat: 1.66,
          lon: 103.6
        }
      }
    }
  }
};